import { AxiosInstance, AxiosResponse } from "axios";
import LogHealthCheck from "../modules/logHealthCheck";

export interface IRestServices {
  root: AxiosInstance;
  health: AxiosInstance;
}

/**
 *
 *
 * @export
 * @enum {string}
 * @see {@link https://confluence.egovdev.ru/pages/viewpage.action?pageId=257120678}
 */
export enum HealthCheckEvents {
  /**
   * @description Авторизация
   */
  authorization = "authorization",
  /**
   * @description Валидация пациента
   */
  patientValidation = "patientValidation",
  /**
   * @description Получение данных пользователя
   */
  getUserData = "getUserData",
  /**
   * @description Просмотр записей на прием к врачу
   */
  getBookingList = "getBookingList",
  /**
   * @description Получение списка регионов
   */
  getRegionList = "getRegionList",
  /**
   * @description Получение списка ЛПУ
   */
  getMOList = "getMOList",
  /**
   * @description Список специальностей
   */
  getSpecialityList = "getSpecialityList",
  /**
   * @description Список врачей
   */
  getSpecialistList = "getSpecialistList",
  /**
   * @description Список слотов
   */
  getSlotList = "getSlotList",
  /**
   * @description Запись к врачу
   */
  booking = "booking",
  /**
   * @description Просмотр записи к врачу
   */
  getBooking = "getBooking",
  /**
   * @description Отмена записи
   */
  cancelBooking = "cancelBooking",
  /**
   * @description Вывод любых ошибок от Группы тестирования
   */
  testingGroupsErrors = "testingGroupsErrors",
  /**
   * @description Вывод любых ошибок из VKBridge
   */
  vkBridgeErrors = "vkBridgeErrors",
  /**
   * @description Вывод любых ошибок из VKBridge
   */
  errorResponse = "errorResponse",
  /**
   * @description Вывод любых ошибок из VKBridge
   */
  errorAuthorization = "errorAuthorization",
  /**
   * @description Ошибки консоли
   */
  consoleError = "consoleError",
  /**
   * @description Сообщения в консоли
   */
  consoleMessage = "consoleMessage",
  /**
   * @description глобальные ошибки
   */
  globalError = "globalError"
}

/**
 * @see {@link https://confluence.egovdev.ru/pages/viewpage.action?pageId=257120678}
 */
export interface ILogHealthCheckDataReq {
  pageId: "60024_vk";
  event: HealthCheckEvents;
  timing?: number;
  result?: 0 | 1;
  serverError?: number;
  browserError?: AxiosResponse["statusText"] | string;
}

export type LogHealthCheckDataParams = Omit<
  ILogHealthCheckDataReq,
  "timing" | "result" | "serverError" | "browserError"
>;

export type LogHealthCheckSuccessParams = Omit<
  ILogHealthCheckDataReq,
  "pageId" | "event" | "browserError"
>;

export type LogHealthCheckErrorParams = Omit<
  ILogHealthCheckDataReq,
  "pageId" | "event" | "serverError"
>;

export type THealthCheckFactory = (
  event: HealthCheckEvents,
  pageId?: string,
) => LogHealthCheck;
